import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, map, merge } from 'rxjs';
import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';

type NetworkStatusState = {
  online: boolean;
};

const initialState: NetworkStatusState = {
  online: navigator.onLine,
};

export const NetworkStatusStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(store => ({
    setOnline(online: boolean): void {
      patchState(store, { online });
    },
  })),
  withHooks({
    onInit(store) {
      merge(
        fromEvent(window, 'online').pipe(map(() => true)),
        fromEvent(window, 'offline').pipe(map(() => false))
      )
        .pipe(takeUntilDestroyed())
        .subscribe(online => store.setOnline(online));
    },
  })
);
